import { type ComponentConfig } from "@puckeditor/core";
import {
  getWindowJobsiteConfig,
  type JobsiteBusinessContext,
} from "../../types/runtime-config";
import { BookingWidget, type BookingWidgetProps } from "./booking-widget";
import { BookingWidgetFields } from "./booking-widget.fields";

export const BookingWidgetConfig: ComponentConfig<BookingWidgetProps> = {
  label: "Booking Widget",
  fields: {
    heading: { ...BookingWidgetFields.heading, contentEditable: true },
    subheading: { ...BookingWidgetFields.subheading, contentEditable: true },
    backgroundColor: BookingWidgetFields.backgroundColor,
  },
  defaultProps: {
    heading: "Book your service",
    subheading: "Pick a time that works — verify by text, no account needed.",
  },
  render: ({ id, puck, ...props }) => {
    // Business slug + apiUrl flow from the injected metadata (Puck editor) or
    // the window runtime config (live jobsite). The booking API resolves on slug.
    const puckMetadata = puck?.metadata as { business?: JobsiteBusinessContext } | undefined;
    const windowConfig = getWindowJobsiteConfig();
    const business = puckMetadata?.business || windowConfig?.business;

    return (
      <BookingWidget
        id={id}
        {...props}
        slug={business?.slug}
        apiUrl={windowConfig?.apiUrl}
        businessName={business?.name}
        businessPhone={business?.phone || business?.telephone}
      />
    );
  },
};
